// extracted by mini-css-extract-plugin
module.exports = {"hoverStyle":"style_hoverStyle__CjPz3","colors":"style_colors__kPjWG","checkBoxStyle":"style_checkBoxStyle__lZwgT","box":"style_box__UUxHs"};